// errors-handler.ts
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { NGXLogger } from 'ngx-logger';
import { JWT_RESPONSE_HEADER } from './constantes';
@Injectable()
export class ErrorsHandler implements ErrorHandler {
    protected logger: NGXLogger;
    constructor(/*protected logger: NGXLogger*/injector: Injector) {
        this.logger = injector.get(NGXLogger);
        this.logger.setWithCredentialsOptionValue(false);
        this.logger.setCustomHttpHeaders(new HttpHeaders({ 'token': `${sessionStorage.getItem(JWT_RESPONSE_HEADER)}` }));
    }

    handleError(error: Error | HttpErrorResponse) {
        this.logger.error(error.name + " :: " + error.message);
        console.error('It happens: ', error);
    }
}